module.exports = __webpack_public_path__ + "img/IMG_9463.e59cf765.jpg";